import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import HelpAndSupport from "./HelpAndSupport";

const HelpAndSupportLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Help And Support" />
      <HelpAndSupport />
    </MasterLayout>
  );
};

export default HelpAndSupportLayout;
